import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import { GeoCoordinates } from 'owa-location-service';

export default function toCoordinate(postalAddress: PersonaPostalAddress): GeoCoordinates {
    if (!postalAddress) {
        return undefined;
    }

    return {
        Latitude: postalAddress.Latitude,
        Longitude: postalAddress.Longitude,
        Altitude: postalAddress.Altitude,
    };
}
